import React from "react";
import { TriggerBuilder } from "@redriver/cinnamon";
import { downloadBookingDocument } from "./actions";
import fileSaver from "file-saver";
import { BaseDocumentTile } from "components/containers";

const DocumentTile = ({ document, bookingRef }) => {
  return (
    <TriggerBuilder
      submitAction={downloadBookingDocument}
      submitParams={{
        fileName: document.name,
        filePath: document.path,
        bookingRef,
      }}
      onSubmitted={(response) => {
        if (response) {
          const byteCharacters = atob(response.data);
          const byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: response.contentType });
          fileSaver.saveAs(blob, document.name);
        }
      }}
      renderTrigger={(fire) => (
        <BaseDocumentTile
          title={document.name}
          fileName={document.name}
          onClick={fire}
        />
      )}
    />
  );
};

export default DocumentTile;
